import { AsYouType, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

import { type ErrorState } from './EditableContactDetails';

export enum InputErrorEnum {
  VALIDATION = 'validation',
  DUPLICATE = 'duplicate',
}
export enum ContentTypeEnum {
  PHONE = 'phone',
  EMAIL = 'email',
}

export const defaultActiveInputValue = {
  value: undefined,
  index: undefined,
};

const isValidEmail = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

const formatDisplayValue = (val: string) => {
  const phoneNumber = parsePhoneNumber(val, {
    defaultCountry: 'US',
  });
  return phoneNumber?.formatNational()?.replaceAll('-', ' ') || val;
};

const formatInputValue = (val: string) => {
  const inputValue = new AsYouType('US');
  inputValue.input(val || '');
  return inputValue?.getNumber()?.formatInternational() ?? '+1';
};

const getInputTitle = (t, type: ContentTypeEnum, index: number) => {
  return t(`player${type[0].toUpperCase() + type.slice(1)}${index}`);
};

export const getErrorMessage = (t, error: ErrorState, activeInput, type: ContentTypeEnum) => {
  if (error?.index === activeInput.index) {
    return error?.type === InputErrorEnum.DUPLICATE ? t(`${type}DuplicateError`) : t(`${type}ErrorMessage`);
  }
  return '';
};

const emailHandlers = {
  isValidInput: (val: string) => isValidEmail(val),
  formatDisplayValue: (val: string) => val,
  formatInputValue: (val: string) => val,
  parseInputValue: (val: string) => val,
  getInputTitle,
  getErrorMessage,
};

const phoneHandlers = {
  isValidInput: (val: string) => isValidPhoneNumber(val),
  formatDisplayValue,
  formatInputValue,
  parseInputValue: (val: string) => parsePhoneNumber(val)?.nationalNumber ?? val,
  getInputTitle,
  getErrorMessage,
};

export const getInputHandlers = (type: ContentTypeEnum) => {
  return type === ContentTypeEnum.PHONE ? phoneHandlers : emailHandlers;
};
